import React from 'react';
// @ts-expect-error TODO: type or globally ignore react-components
import { LoadingSpinner } from '@checkout/react-components';
// @ts-expect-error TODO: exported members
import { lazyLoader } from '@/lib';

const LazyResidentialAddressInterstitial = lazyLoader({
  loader: () => import('@/components/Interstitials/ResidentialAddress'),
  loading: () => <LoadingSpinner />,
  name: 'residential_address_interstitial',
  render(loaded: any, props: any) {
    const Component = loaded.ResidentialAddressInterstitial;
    return <Component {...props} />;
  },
});

export { LazyResidentialAddressInterstitial };
